module.exports = __webpack_public_path__ + "img/dao.426a28a7.png";